import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { MosaicViewManager } from 'src/components/mosaic/MosaicViewManager';
import { MosaicCollapseOptionsById } from 'src/components/mosaic/types';
import {
  MosaicSplitOptions,
  MosaicSplitType,
  NestedMosaicParentInitial,
  ProjectTileId,
} from 'src/constants/mosaic';
import { ROUTE } from 'src/constants/routes';
import { ProjectNavbar } from 'src/containers/Project/ProjectNavbar';
import { useMappingFromRoute } from 'src/containers/ProjectMapping/hooks/useMappingFromRoute';
import { ProjectMappingSidebar } from 'src/containers/ProjectMapping/ProjectMappingSidebar';
import { ProjectMappingView } from 'src/containers/ProjectMapping/ProjectMappingView';
import { useHasProject } from 'src/utils/hooks/useHasProject';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';
import { getProjectMappingRoute } from 'src/utils/routes/getProjectMappingRoute';

const COLLAPSE_OPTIONS: MosaicCollapseOptionsById<ProjectTileId> = {
  [ProjectTileId.SIDEBAR]: {
    collapsible: true,
    collapsed: false,
    collapsedSize: 15,
    collapsedVisible: false,
  },
};

const INITIAL_VALUE: NestedMosaicParentInitial<ProjectTileId> = {
  direction: 'row',
  first: ProjectTileId.SIDEBAR,
  second: ProjectTileId.VIEW,
};

const SPLIT_OPTIONS: MosaicSplitOptions = {
  firstMinSplitType: MosaicSplitType.NUMBER,
  firstMinSplitValue: 300,
  secondMinSplitType: MosaicSplitType.NUMBER,
  secondMinSplitValue: 900,
  initialSplitPercentage: 20,
};

export const ProjectMapping: React.VFC = () => {
  const { mappingId, projectId } = useRouterParams<'PROJECT_MAPPING'>();
  const mapping = useMappingFromRoute();
  const hasProject = useHasProject();

  if (!hasProject) {
    return <Redirect to={ROUTE.HOME} />;
  }

  if (mappingId && !mapping) {
    return <Redirect to={getProjectMappingRoute(projectId)} />;
  }

  return (
    <>
      <ProjectNavbar />

      <MosaicViewManager
        collapseOptions={COLLAPSE_OPTIONS}
        containerClassName="sd-project-mapping sd-container"
        initialValue={INITIAL_VALUE}
        splitOptions={SPLIT_OPTIONS}
      >
        <ProjectMappingSidebar id={ProjectTileId.SIDEBAR} />
        <ProjectMappingView id={ProjectTileId.VIEW} />
      </MosaicViewManager>
    </>
  );
};
